import { TRAVEL_FEATURES } from './CurrentDocument';


export default TRAVEL_FEATURES;
